import { React } from 'react';
import { Container, Row, Stack } from "react-bootstrap";
import { useConfig } from 'contexts/ConfigContext';
import packageJson from '../../../package.json';


const currentYear = new Date().getFullYear();

export function Footer() {

  const { configData } = useConfig();

  return(
    <Container fluid className="Footer">
      <Row>
        <Stack direction="horizontal" className="justify-content-center">
                  <div className="mt-3 text-center">Copyright &copy; Tunstall {currentYear} <small>(versi&oacute;n: {packageJson.version}/{configData.versionApi})</small></div>
        </Stack>
      </Row>
    </Container>
  )
}